module.exports = __webpack_public_path__ + "img/acornhand-cut.925184a9.jpg";